


























import Vue from 'vue';
import { mapGetters } from 'vuex';
import { SAVE_STATE, LOAD_STATE } from '@/store/shared';
import eventBus from '@/helpers/event-bus';
import {
  FETCH_REACTIVATION_CAMPAIGN_BLUEPRINT,
  PUBLISH_REACTIVATION_CAMPAIGN_BLUEPRINT,
  SCHEDULE_SAVE_REACTIVATION_CAMPAIGN_BLUEPRINT,
  UPDATE_REACTIVATION_CAMPAIGN_BLUEPRINT,
} from '@/store/action-types';
import {
  SET_REACTIVATION_CAMPAIGN_EMAIL,
  SET_CURRENT_REACTIVATION_CAMPAIGN_BLUEPRINT_ID,
  SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID,
  STORE_REACTIVATION_CAMPAIGN_BLUEPRINT_DATA,
} from '@/store/mutation-types';
import { ICampaignBlueprint, IEmailBlueprint, IState, IUser } from '@/store/types';
import CampaignSequence from '@/components/Reactivation/CampaignSequence.vue';
import EmailEditor from '@/components/Reactivation/EmailEditor.vue';
import CampaignEditorLoader from '@/components/UI/Loader/CampaignEditorLoader.vue';
import { generateEmailBlueprint } from '@/helpers/templates';

export default Vue.extend({
  name: 'CampaignEditor',
  components: {
    CampaignSequence,
    EmailEditor,
    CampaignEditorLoader,
  },
  data() {
    return {
      SAVE_STATE,
      LOAD_STATE,
      publishLoading: false,
      loadingCampaignBlueprint: true,
    };
  },
  async created() {
    const state = this.$store.state as IState;
    await this.$store.dispatch(FETCH_REACTIVATION_CAMPAIGN_BLUEPRINT, this.$route.params.id);
    this.$store.commit(SET_CURRENT_REACTIVATION_CAMPAIGN_BLUEPRINT_ID, this.$route.params.id);
    if (this.currentReactivationCampaignEmailBlueprints) {
      this.$store.commit(SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID, this.currentReactivationCampaignEmailBlueprints[0].guid);
    }
    this.loadingCampaignBlueprint = false;
  },
  computed: {
    ...mapGetters([
      'reactivationCampaignBlueprints',
      'currentReactivationCampaignBlueprint',
      'currentReactivationCampaignBlueprintId',
      'currentReactivationCampaignBlueprintLoadState',
      'currentReactivationCampaignBlueprintSaveState',
      'currentReactivationEmailBlueprint',
      'currentReactivationCampaignEmailBlueprints',
      'currentReactivationCampaignEmailBlueprintMap',
      'userOrgSubscription',
      'isAdmin',
      'isLocal',
      'payingCustomer',
    ]),
    campaignBlueprintId(): string {
      return this.$route.params.id;
    },
    campaignBlueprint(): ICampaignBlueprint | undefined {
      if (!this.campaignBlueprintId) {
        return undefined;
      }
      return this.$store.state.reactivationCampaignBlueprints[this.campaignBlueprintId];
    },
    user(): IUser {
      return this.$store.state.user;
    },
  },
  methods: {
    openChat(): void {
      eventBus.$emit('openChat');
    },
    scheduleSave() {
      this.$store.dispatch(SCHEDULE_SAVE_REACTIVATION_CAMPAIGN_BLUEPRINT, { id: this.campaignBlueprintId });
    },
    emailUpdate(email: IEmailBlueprint, update: any, field?: string) {
      const state = this.$store.state as IState;
      const emailId = email.guid;
      const campaignId = state.currentReactivationCampaignBlueprintId;
      // nested updated on the step
      if (field) {
        // @ts-ignore
        const existingField = email[field];
        const fieldUpdate = {
          ...existingField,
          ...update,
        };
        this.$store.commit(SET_REACTIVATION_CAMPAIGN_EMAIL, {
          emailId,
          campaignId,
          data: {
            ...email,
            [field]: fieldUpdate,
            saveState: SAVE_STATE.UNSAVED,
          },
        });
      } else {
        this.$store.commit(SET_REACTIVATION_CAMPAIGN_EMAIL, {
          emailId,
          campaignId,
          data: {
            ...email,
            ...update,
            saveState: SAVE_STATE.UNSAVED,
          },
        });
      }
      this.scheduleSave();
    },
    addEmail(): void {
      const state = this.$store.state as IState;
      const lastEmail = this.currentReactivationCampaignEmailBlueprints[
        this.currentReactivationCampaignEmailBlueprints.length - 1
      ] as IEmailBlueprint;
      const newEmail = generateEmailBlueprint({
        ...lastEmail,
        sendOnDay: lastEmail.sendOnDay + 1,
      });
      newEmail.saveState = SAVE_STATE.UNSAVED;
      const newEmailSequence = this.currentReactivationCampaignEmailBlueprints.concat(newEmail);
      this.$store.commit(STORE_REACTIVATION_CAMPAIGN_BLUEPRINT_DATA, {
        id: state.currentReactivationCampaignBlueprintId,
        data: {
          emails: newEmailSequence,
          saveState: SAVE_STATE.UNSAVED,
        },
      });
      this.$store.commit(SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID, newEmail.guid);
      this.scheduleSave();
    },
    async markForDelete(id: string) {
      const state = this.$store.state as IState;
      const email = this.currentReactivationCampaignEmailBlueprintMap[id];
      this.emailUpdate(email, { delete: true });
      if (state.currentReactivationEmailBlueprintId === id) {
        this.$store.commit(
          SET_CURRENT_REACTIVATION_EMAIL_BLUEPRINT_ID,
          this.currentReactivationCampaignEmailBlueprints.filter((d: IEmailBlueprint) => !d.delete)[0].guid
        );
      }
      this.scheduleSave();
    },
  },
});
